import l from "react";
import d from "@appchoose/cn";
const u = l.forwardRef(
  ({
    type: o = "button",
    appearance: a = "primary",
    size: t = "medium",
    containsIcon: e = !1,
    children: b,
    className: g,
    ...m
  }, s) => {
    const y = (r) => d(
      "inline-flex items-center font-bold transition-colors duration-300 outline-none focus-visible:ring-2 focus-visible:ring-gray-900/30 disabled:cursor-not-allowed",
      {
        rounded: t === "small",
        "rounded-lg": t !== "small",
        "bg-red-600 border-red-600 text-white hover:bg-red-375 hover:border-red-375 disabled:bg-red-300 disabled:border-red-300": r === "danger",
        "bg-gray-900 border-gray-900 text-white hover:bg-gray-700 hover:border-gray-700 disabled:bg-gray-300 disabled:border-gray-300": !r || r === "primary",
        "bg-white text-gray-900 border-gray-900 hover:text-gray-700 hover:border-gray-700 disabled:text-gray-300 disabled:border-gray-300": r === "outline"
      }
    ), x = (r) => d({
      border: r === "small",
      "border-2": r !== "small",
      "text-xs p-1.75": (!r || r === "small") && e,
      "text-xs px-2.5 py-1.75": (!r || r === "small") && !e,
      "text-sm px-3.5 py-2": (!r || r === "medium") && !e,
      "text-sm p-1.5": (!r || r === "medium") && e,
      "text-md px-9.5 py-3.5": r === "large" && !e,
      "text-md p-4": r === "large" && e
    });
    return /* @__PURE__ */ l.createElement(
      "button",
      {
        ref: s,
        type: o,
        className: d(
          y(a),
          x(t),
          g
        ),
        ...m
      },
      b
    );
  }
);
u.displayName = "Button";
export {
  u as default
};
